/* eslint complexity: 0 */

/**
 * Kit reducer
 */

import _merge from "lodash/merge";
import _union from "lodash/union";
import _mergeWith from "lodash/mergeWith";
import { Repo } from "@thenounproject/lingo-core";

import * as actionTypes from "../../actions/actionTypes";

const kitReducer = (state = {}, action) => {
  let kits;
  try {
    kits = action.response.entities.kits;
  } catch (error) {
    // That's ok
  }

  const actionRepo = new Repo(action.response || {});

  // Because action.uuid can be a uuid or shortId
  // This looks makes the conversion if necessary.
  // We could instantiate a repo with `state` but this does this same thing
  // without the overhead of initializing a repo object
  function getKitUuid(id) {
    if (state[id]) return id;
    return (Object.values(state).find(k => k.shortId === id) || {}).kitId;
  }

  switch (action.type) {
    case actionTypes.FETCH_KIT_SUCCESS: {
      const kit = actionRepo.getKit(action.uuid);
      kit.deletedSinceFetch = false;
      kit.modifiedSinceFetch = false;
      return Object.assign({}, state, { [kit.kitId]: kit });
    }
    case actionTypes.CREATE_KIT_VERSION_SUCCESS:
    case actionTypes.FETCH_KIT_VERSION_SUCCESS: {
      const kitUuid = getKitUuid(action.uuid),
        kit = state[kitUuid],
        versionId = action.response.result;

      let versions = kit.versions.slice(0);
      versions.push(versionId);
      versions = [...new Set(versions)];

      return _merge({}, state, {
        [kitUuid]: { versions },
      });
    }
    case actionTypes.FETCH_KIT_OUTLINE_SUCCESS: {
      const kitVersions = action.response.entities.kitVersions,
        versionState = {};

      Object.entries(kitVersions).forEach(kv => {
        const kitUuid = [kv[1].kitId],
          versionId = kv[0],
          stateKit = state[kitUuid],
          versions = stateKit ? _union(stateKit.versions, [versionId]) : [versionId];
        Object.assign(versionState, { [kitUuid]: { versions: versions } });
      });

      return _merge({}, state, versionState);
    }
    case actionTypes.FETCH_KIT_OUTLINE_FAILURE: {
      const kitUuid = getKitUuid(action.uuid),
        stateKit = state[kitUuid],
        version = action.version;

      if (!stateKit || !stateKit.access) return state;
      if (stateKit.access.useVersion === null) return state;

      if (stateKit.access.useVersion === version) {
        return _merge({}, state, {
          [action.uuid]: { access: { useVersion: null } },
        });
      }

      return state;
    }
    case actionTypes.DELETE_KIT_VERSION_SUCCESS: {
      const kitUuid = getKitUuid(action.uuid),
        kit = state[kitUuid],
        versionId = action.response.result;

      return Object.assign({}, state, {
        [kitUuid]: Object.assign({}, kit, {
          versions: kit.versions.filter(v => v !== versionId),
        }),
      });
    }
    case actionTypes.FETCH_KIT_FAILURE: {
      const kit = {};
      if (action.statusCode === 404) {
        kit.deleted = true;
      } else {
        kit.error = action.error;
      }
      return _merge({}, state, { [action.uuid]: kit });
    }

    case actionTypes.SET_KIT_USE_VERSION:
    case actionTypes.SET_KIT_USE_VERSION_SUCCESS: {
      return _merge({}, state, {
        [action.kitUuid]: { access: { useVersion: action.version } },
      });
    }
    case actionTypes.SET_KIT_FAVORITE: {
      return _merge({}, state, {
        [action.kitUuid]: { access: { isFavorite: action.isFavorite } },
      });
    }
    case actionTypes.SET_KIT_FAVORITE_FAILURE: {
      return _merge({}, state, {
        [action.kitUuid]: { access: { isFavorite: !action.isFavorite } },
      });
    }
    case actionTypes.DELETE_KIT_SUCCESS: {
      const uuid = action.uuid;
      return _merge({}, state, { [uuid]: { status: "deleted" } });
    }
    case actionTypes.EDIT_KIT_SUCCESS:
    case actionTypes.SEARCH_SPACE_SUCCESS:
    default: {
      if (kits) {
        return _merge({}, state, kits);
      }
      return state;
    }
  }
};

export default kitReducer;

export const getKits = state => {
  return state.entities.kits;
};

export const getKitsByUuid = state => uuids => {
  const kits = getKits(state),
    uuidArray = typeof uuids === "string" ? [uuids] : uuids;

  return Object.values(kits).filter(k => uuidArray.includes(k.kitId));
};
